import { StrictMode } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import 'react-phone-input-2/lib/style.css';
import App from './App';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <StrictMode>
    <App />
  </StrictMode>
);
